import {Component} from 'substance'
import prettifyXml from 'prettify-xml'

class SourceComponent extends Component {

    constructor(...args) {
        super(...args)
        this.editor = null
    }

    didMount() {
        const xmlString = prettifyXml(
            this.props.xml,
            {indent: 4}
        )
        window.require(['vs/editor/editor.main'], () => {
            this.editor = window.monaco.editor.create(
                document.getElementById('newsmlsource'),
                {
                    value: xmlString,
                    language: 'xml',
                    renderIndentLines: true,
                    readOnly: false,
                    renderLineHighlight: 'gutter',
                    scrollBeyondLastLine: true,
                    minimap: {
                        enabled: false
                    }
                }
            )
            window.__editor = this.editor
        })
    }

    render($$) {
        return $$('div').attr('id', 'newsmlsource').css({
            position: 'absolute',
            top: '0',
            left: '0',
            right: '0',
            bottom: '0',
            padding: '0.6rem'
        })
    }


    onClose() {
    }

}

export default SourceComponent
